import type { ClockKind } from '../../../api/time_clock/requests'

export const clockTones = {
  purple: { ink: '#5d5ecb', soft: '#f0effb', border: '#dfdff5' },
  green: { ink: '#267666', soft: '#eaf8f3', border: '#c8e9dd' },
  amber: { ink: '#956016', soft: '#fff6e3', border: '#f2ddb0' },
  pink: { ink: '#ad457b', soft: '#fff0f6', border: '#f3d5e5' },
  red: { ink: '#b21634', soft: '#fff0f3', border: '#fadbe1' },
  gray: { ink: '#666d80', soft: '#f5f6fa', border: '#e7e8ef' },
} as const

export type ClockTone = keyof typeof clockTones

const toneStates: [ClockTone, Set<string>][] = [
  [
    'green',
    new Set(['working', 'approved', 'complete', 'inside', 'flag_acknowledged', 'flag_approved_remote', 'pause_ok']),
  ],
  [
    'purple',
    new Set(['confirmed', 'in_progress', 'correction_pending', 'pending', 'flag_check_requested', 'pause_due']),
  ],
  [
    'amber',
    new Set([
      'paused',
      'pause_short',
      'auto_closed',
      'changed',
      'outside',
      'unavailable',
      'flag_open',
      'pause_too_short',
      'pause_missing',
    ]),
  ],
  ['red', new Set(['missing'])],
]

export function clockStateTone(state: string): ClockTone {
  return toneStates.find(([, states]) => states.has(state))?.[0] || 'gray'
}

/** Header positions stay stable; only server-authorised actions can be used. */
export function clockActionItems(allowed: readonly ClockKind[], compact: boolean) {
  const kinds: readonly ClockKind[] = compact
    ? ['in', allowed.includes('pause_end') ? 'pause_end' : 'pause_start', 'out']
    : allowed
  return kinds.map((kind) => ({ kind, enabled: allowed.includes(kind) }))
}
